import { render } from "./kaidan.vue?vue&type=template&id=1c4d3c33&scoped=true"
import script from "./kaidan.vue?vue&type=script&lang=js"
export * from "./kaidan.vue?vue&type=script&lang=js"

import "./kaidan.vue?vue&type=style&index=0&id=1c4d3c33&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4d3c33"]])

export default __exports__